import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { PreLoginComponent } from './components/preLogin/prelogin';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'prelogin', component: PreLoginComponent},
  { path: '', loadChildren: () => import('./paginas/paginas.module').then(m => m.PaginasModule) },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
